export { DsCheckboxModule } from './src/checkbox.module';
export { DsCheckboxSize } from './src/checkbox.interface';
export { DsCheckboxComponent } from './src/components/checkbox/checkbox.component';
